export const scrollTop = () => {
  document.getElementsByClassName('pageview-wrapper')[0].scrollTo({top: 0, behavior: 'smooth'});
};